import styled, { keyframes } from 'styled-components'
import { spin } from './LoginLoading.styles'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const settle = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: ${({ theme }) =>
    theme?.typography?.fontFamily || 'Poppins, system-ui, sans-serif'};
  color: ${({ theme }) => theme?.colors?.textPrimary || '#21262D'};
  background:
    radial-gradient(ellipse 80% 60% at 50% -10%, rgba(62, 207, 142, 0.18), transparent 55%),
    ${({ theme }) => theme?.colors?.background || '#FFFFFF'};
  animation: ${fadeIn} 0.28s ease-out both;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: ${settle} 0.42s 0.06s ease-out both;
`

export const BrandRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 1.75rem;
`

export const BrandName = styled.span`
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme?.colors?.textPrimary || '#21262D'};
`

export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  margin-bottom: 14px;
  border: 3px solid ${({ theme }) => theme?.colors?.borderDefault || '#E2E8F0'};
  border-top-color: ${({ theme }) =>
    theme?.colors?.action?.primary?.bg || '#3ECF8E'};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const Title = styled.p`
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme?.colors?.textPrimary || '#21262D'};
`

export const Subtitle = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.45;
  color: ${({ theme }) => theme?.colors?.textMuted || '#8390A2'};
`
